import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-savingsinterestsettings',
  templateUrl: './savingsinterestsettings.component.html',
  styleUrls: ['./savingsinterestsettings.component.css']
})
export class SavingsinterestsettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
